import { each, get, has, isEmpty } from 'lodash'
import { BrowserRouter as Router } from 'react-router-dom'
import React, { useContext, useEffect, useState, useRef } from 'react'
import {
  BookInfo, Errors,
  MenuAppendicesFiltered,
  MenuContext,
  MenuFiltered,
  MenuMaterialsFiltered,
} from '../contexts/menuContext'
import TabsMenu from './navigation/tabs'
import MobileMenu from './navigation/MobileMenu'
import Controls from './controls/controls'
import BookContent from './book/bookContent'
import BookMaterials from './book/bookMaterials'
import RightSidebar from './controls/rightSidebar'
import { getRelation } from '../api/getRelation'

const drupalSettings = { nclc_book: { bookReader: { data: [{ url: '/book/test-book', type: 'book' }] } } }
const AppContent = () => {
  // TODO: transform default variables to the Drupal settings + get requests, depended on each way.
  // Navigation variables.
  const { nclc_book: { bookReader: bookSettings } } = window.drupalSettings || drupalSettings
  const [menuStatus] = useContext(MenuContext)
  const [book, setBook, page, setPage] = useContext(BookInfo)
  const [error, setError] = useContext(Errors)
  const bookInfo = bookSettings.data.find((data) => {
    return data.type === 'book'
  })
  const navigation = get(bookInfo, 'relationships.navigation', {})
  const children = [...get(book, 'relationships.navigation.overview', []), ...get(navigation, 'chapter', [])]
  const appendicesMenuUrl = get(navigation, 'appendix', '')
  // State will be using for Context.
  const [chapterMenu, changeChapterMenu] = useState(children)
  const [materialsMenu, changeMaterialsMenu] = useState({})
  const [appendicesMenu, changeAppendicesMenu] = useState({})
  const [appendicesMenuOriginal, changeAppendicesMenuOriginal] = useState({})
  const [activeMenu, setActiveMenu] = useState(get(book, 'page_type', 'chapters'))
  const [lastActivePageByType, setLastActivePageByType] = useState({})
  const [positionData, setPositionData] = useState({})
  const bookContentEl = useRef(null);

  const changeActiveMenu = (e) => {
    let currentPageType = get(book, 'page_type', 'chapters')
    let newPageType = (e === 'index') ? 'chapters' : e

    lastActivePageByType[currentPageType] = !isNaN(page) ? page : null
    setLastActivePageByType(lastActivePageByType)

    let lastActivePageId = get(lastActivePageByType, newPageType, null)
    setPage(lastActivePageId)

    setActiveMenu(e)
    setBook({ ...book, page_type: e })
  }

  useEffect(() => {
    setActiveMenu(get(book, 'page_type', 'chapters'))
  }, [book])

  useEffect(() => {
    getRelation(appendicesMenuUrl).then((data) => {
      const arg = data?.data?.0 : {}
      changeAppendicesMenu(arg)
      changeAppendicesMenuOriginal(arg)
    })
    /*
    Temporary comment this because we are redirecting the user to the search page
    getRelation(companionMenuUrl).then((data) => {
      changeMaterialsMenu([first(values(data.data))])
    })*/
    // eslint-disable-next-line
  }, [])
  // variable for the flat structure.
    
  const navArray = []

  const flag_info = bookSettings.data[0].relationships.flags;

  const getMenuItemFlags = (item, flags) => {
    let flag_subset = {};

    if (has(item, 'subsection_id') && flags[item.subsection_id]) {
      flag_subset = flags[item.subsection_id];
    }

    return flag_subset;
  };

  // Let's flat the items to detect prev next component.
  const menuTreeRecursive = (menuItemGroup, flags = flag_info) => {
    each(menuItemGroup, (menuItem) => {
      let tmp_flags = getMenuItemFlags(menuItem, flags);

      if (has(tmp_flags, 'flags')) {
        menuItem.flags = tmp_flags.flags;
      }

      if (!isEmpty(menuItem.children)) {
        menuTreeRecursive(menuItem.children, tmp_flags)
      } else if (has(menuItem, 'value.id')) {
        navArray.push(menuItem.value)
      }
    })
  }

  const navigationList = []
  const navigationListCreate = (menu) => {
    if (!isEmpty(menu) && page) {
      const filtered = menu.find((item) => {
        return JSON.stringify(item).search(`"${page.replace('p_', '')}"`) > -1
      })
      if (filtered) {
        navigationList.push(filtered.value)
        navigationListCreate(get(filtered, 'children', []))
      }
    }
  }

  if (activeMenu === 'appendices') {
    if (isEmpty(appendicesMenu)) {
      getRelation(appendicesMenuUrl).then((data) => {
        changeAppendicesMenu(data.data[0])
        menuTreeRecursive(appendicesMenu)
        navigationListCreate(appendicesMenu)
      })
    }
    else {
      menuTreeRecursive(appendicesMenu)
      navigationListCreate(appendicesMenu)
    }
    if (isEmpty(appendicesMenuOriginal)) {
      getRelation(appendicesMenuUrl).then((data) => {
        changeAppendicesMenuOriginal(data.data[0])
        menuTreeRecursive(appendicesMenuOriginal)
        navigationListCreate(appendicesMenuOriginal)
      })
    }
    else {
      menuTreeRecursive(appendicesMenuOriginal)
      navigationListCreate(appendicesMenuOriginal)
    }
  } else {
    menuTreeRecursive(children)
    navigationListCreate(children)
  }

  useEffect(() => {
    if (error) {
      setTimeout(() => { setError('') }, 7000)
    }
  }, [error, setError])

  navigationList.shift()
  return (
    <Router>
      <div className="App">
        {error && <div className="alert alert-danger alert-dismissible fade show" role="alert">
          <div dangerouslySetInnerHTML={{ __html: error }}/>
          <button
            onClick={() => { setError('') }}
            type="button"
            className="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>}

        <div className="app-content">
          <>
            <MenuFiltered.Provider value={[chapterMenu, changeChapterMenu]}>
              <MenuAppendicesFiltered.Provider value={[appendicesMenu, changeAppendicesMenu]} >
                <MenuMaterialsFiltered.Provider value={[materialsMenu, changeMaterialsMenu]} >
                  {/*TODO: when we'll have full vision on the menus data, we should build one
                        // context for all menus instead of using each context for each menu.
                        // Added different context for the each menu. */}
                  <TabsMenu navigation={children} activeMenu={activeMenu} changeActiveMenu={changeActiveMenu} appendicesMenu={appendicesMenuOriginal} materialsMenu={materialsMenu}/>
                </MenuMaterialsFiltered.Provider>
              </MenuAppendicesFiltered.Provider>
            </MenuFiltered.Provider>
            <div
              className={menuStatus ? 'book-content' : 'book-content maximized'}
              data-whatnew={get(book, 'whatNew', true)}
            >
              <MenuFiltered.Provider value={[chapterMenu, changeChapterMenu]}>
                <MenuAppendicesFiltered.Provider
                  value={[appendicesMenu, changeAppendicesMenu]}
                >
                  <MenuMaterialsFiltered.Provider value={[materialsMenu, changeMaterialsMenu]} >
                    <MobileMenu
                      activeMenu={activeMenu}
                      changeActiveMenu={changeActiveMenu}
                      navigation={children}
                      appendices={appendicesMenu}
                      appendicesMenu={appendicesMenuOriginal}
                      material={materialsMenu}
                    />
                  </MenuMaterialsFiltered.Provider>
                </MenuAppendicesFiltered.Provider>
              </MenuFiltered.Provider>

              {/*Placeholder for the right navigation.*/}
              <div
                className="bookreader-main-content-wrap"
                ref={bookContentEl}
                >
                <Controls
                  page={page}
                  navigation={activeMenu === 'appendices' && !isEmpty(appendicesMenu) ? appendicesMenu : children}
                  navigationList={navigationList}
                  materials={activeMenu === 'materials'}
                />
                {/*TODO: change the routing based o the Drupal implementation*/}
                {/*Here we should handle book path to render initial data*/}

                {/*Main component for the book content*/}
                {activeMenu === 'materials' ?
                  <MenuMaterialsFiltered.Provider value={[materialsMenu, changeMaterialsMenu]} >
                    <BookMaterials navArray={navArray} />
                  </MenuMaterialsFiltered.Provider> :
                  <BookContent navArray={navArray} />}
              </div>
              <RightSidebar />
            </div>
          </>
        </div>
      </div>
    </Router>
  )
}

export default AppContent
